import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Copy, Gift, X } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import { useAuth } from "../auth";
import { useLanguage } from "../i18n";

/** Banner referral in home per utenti loggati: link personale pronto da condividere. */
export default function ReferralBanner() {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [link, setLink] = useState(null);
  const hideKey = user ? `atlas_refbanner_hide_${user.user_id}` : null;
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) { setLink(null); return; }
    try { setDismissed(!!localStorage.getItem(`atlas_refbanner_hide_${user.user_id}`)); } catch { /* ignore */ }
    api.get("/referrals/mine").then(({ data }) => setLink(data.data?.link || null)).catch(() => {});
  }, [user]);

  if (!user || !link || dismissed) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success(t("ref.copied")); } catch { /* clipboard negato */ }
  };
  const hide = () => {
    try { localStorage.setItem(hideKey, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <section data-testid="referral-banner" className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto pt-4">
      <div className="relative overflow-hidden rounded-3xl bg-[#1E293B] text-white px-6 sm:px-10 py-8 sm:py-9">
        <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#FF6B35]/15 blur-2xl" aria-hidden="true" />
        <button data-testid="referral-banner-close" onClick={hide} aria-label="chiudi"
          className="absolute top-4 right-4 rounded-full p-1.5 text-slate-400 hover:text-white hover:bg-white/10 transition-colors">
          <X className="w-4 h-4" />
        </button>
        <div className="flex flex-wrap items-center gap-5 sm:gap-8">
          <div className="shrink-0 w-12 h-12 rounded-2xl bg-[#FF6B35] flex items-center justify-center shadow-lg shadow-orange-900/40">
            <Gift className="w-6 h-6 text-white" />
          </div>
          <div className="min-w-0 flex-1 basis-64">
            <h2 className="font-display font-extrabold text-xl sm:text-2xl">{t("refbanner.title")}</h2>
            <p className="text-sm text-slate-300 mt-1 max-w-xl">{t("refbanner.sub")}</p>
          </div>
          <div className="flex items-center gap-2.5 flex-wrap">
            <button data-testid="referral-banner-copy" onClick={copy}
              className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-2.5 font-mono-t text-[11px] hover:bg-white/15 transition-colors max-w-[260px]">
              <Copy className="w-3.5 h-3.5 shrink-0" />
              <span data-testid="referral-banner-link" className="truncate">{link}</span>
            </button>
            <Link data-testid="referral-banner-cta" to="/account?tab=referral"
              className="inline-flex items-center gap-1.5 rounded-full bg-[#FF6B35] px-5 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-[0.15em] hover:bg-[#E8551F] transition-colors">
              {t("refbanner.cta")} <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
